import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  TableRow,
  TableCell,
  Checkbox,
  TableBody,
  Table
} from '@material-ui/core';
import { updateQuotePlanSelectedSeries } from 'redux/actions/quote';
import { useStyles } from '../styles';
import QuoteSeriesItemRow from './QuoteSeriesItemRow';
import ProgressItemSymbol from './ProgressItemSymbol';
import QuoteSeriesName from './QuoteSeriesName';
import EditTimelineButton from './EditTimelineButton';


const QuoteTreatmentPlanRow = ({
  series,
  seriesIndex,
  isLastSeries
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const {
    _id,
    name: seriesName,
    selectedItems
  } = series;

  const {
    quotePlanSelectedSeriesIds
  } = useSelector((state: IReduxState) => state.quote);

  return (
    <TableRow key={_id} className={classes.noBorder}>
      <TableCell padding="checkbox">
        <Checkbox
          checked={quotePlanSelectedSeriesIds.includes(_id)}
          color="primary"
          className="mt-2"
          onChange={({target: {checked}}) => dispatch(updateQuotePlanSelectedSeries(_id, checked))}
        />
      </TableCell>
      <TableCell>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell width="370" padding="none">
                <QuoteSeriesName name={seriesName} seriesId={_id} />
              </TableCell>
              <TableCell padding="none" className="h-full relative" width="80">
                <ProgressItemSymbol isFirst={seriesIndex === 0} isLast />
              </TableCell>
              <TableCell colSpan={3} />
            </TableRow>
          </TableBody>
        </Table>
        <Table>
          <TableBody>
            {selectedItems.map((item, index) => (
              <QuoteSeriesItemRow
                key={item._id}
                item={item}
                itemIndex={index}
                seriesIndex={seriesIndex}
                isLastSeries={isLastSeries}
                isLastItem={index === selectedItems.length - 1}
              />
            ))}
            <TableRow>
              <TableCell width="80" />
              <TableCell  width="270">
                <EditTimelineButton series={series} />
              </TableCell>
              <TableCell padding="none" className="h-full relative">
                <ProgressItemSymbol isFirst={isLastSeries} isLast={isLastSeries} />
              </TableCell>
              <TableCell colSpan={3} />
            </TableRow>
          </TableBody>
        </Table>
      </TableCell>
    </TableRow>
  );
};

export default QuoteTreatmentPlanRow;
